import { Component,
         OnInit,
         Input }                    from '@angular/core';
import { MediaModel }               from '../../../common/media.model';
import { DomSanitizer,
         SafeStyle }                from 'node_modules/@angular/platform-browser';
import { Globals }                  from '../../../common/globals';
import { CompanyService }           from '../../../shared/company.service';
import { CompanyViewModel }         from '../../../setting/company/company-view.model';
import { WalletTemplateModel }      from '../../../common/wallet-template.model';
import { WalletGoogleField }        from '../../../common/wallet-template-enums';
import { WalletCommon, EvaluatedField }             from '../wallet-common/wallet-common.functions';
import { GalleryService } from '../../../shared/gallery.service';
import { GoogleWalletPassStyle } from 'src/app/common/wallet-passstyle-enum';
import { WalletBarcodeType } from 'src/app/common/wallet-barcode-type.enum';
import { isNullOrWhitespace } from 'src/app/common/functions';
import { TranslationService } from 'src/app/shared/translation.service';

@Component({
  selector: 'hc-wallet-android',
  templateUrl: './wallet-android.component.html',
  styleUrls: ['./wallet-android.component.scss']
})
export class WalletAndroidComponent extends WalletCommon implements OnInit {

  activeCompany: CompanyViewModel;

  @Input()
  mediaModel: MediaModel;

  @Input()
  walletTemplate: WalletTemplateModel;

  passStyle = GoogleWalletPassStyle;

  walletBarcodeType = WalletBarcodeType;

  walletGoogleField = WalletGoogleField;

  

  private _globals: Globals;
  get getGlobals() {
    return this._globals;
  }

  private _sanitizer: DomSanitizer;
  get getSanitizer() {
    return this._sanitizer;
  }

  public getGoogleFieldValue(fieldType: WalletGoogleField): string {
    return this.getFieldValue(fieldType, this.walletTemplate, this.mediaModel);
  }

  public anyField(fields: Array<any>): boolean {
    if (!fields || fields.length === 0) return false;
    return fields.filter(f => !isNullOrWhitespace(this.getGoogleFieldLabel(f))).length > 0;
  }

  public getGoogleFieldLabel(fieldType: WalletGoogleField): string {
    return this.getFieldLabel(fieldType, this.walletTemplate, this.mediaModel);
  }

  get IssuerName(): string {
    return this.getGoogleFieldValue(WalletGoogleField.IssuerName);
  }

  get ProgramName(): string {
    return this.getGoogleFieldValue(WalletGoogleField.ProgramName);
  }

  get SubHeader(): string {
    return this.getGoogleFieldLabel(WalletGoogleField.TopRowSubheader);
  }

  get Header(): string {
    return this.getGoogleFieldLabel(WalletGoogleField.TopRowHeader);
  }


  get LoyaltyPoints(): string {
    return this.getGoogleFieldValue(WalletGoogleField.LoyaltyPoints);
  }

  get LoyaltyPointsLabel(): string {
    return this.getGoogleFieldLabel(WalletGoogleField.LoyaltyPoints);
  }

  
  get SecondaryLoyaltyPoints(): string {
    return this.getGoogleFieldValue(WalletGoogleField.SecondaryLoyaltyPoints);
  }

  get SecondaryLoyaltyPointsLabel(): string {
    return this.getGoogleFieldLabel(WalletGoogleField.SecondaryLoyaltyPoints);
  }

  get AccountNameLabel(): string {
    return this.getGoogleFieldLabel(WalletGoogleField.TopRowSubheader);
  }

  get AccountName(): string {
    return this.getGoogleFieldValue(WalletGoogleField.TopRowHeader);
  }

  get AccountIdLabel(): string {
    return this.getGoogleFieldLabel(WalletGoogleField.AccountId);
  }

  get AccountId(): string {
    return this.getGoogleFieldValue(WalletGoogleField.AccountName);
  }

  get RewardsTierLabel(): string {
    return this.getGoogleFieldLabel(WalletGoogleField.Row2Right);
  }

  get RewardsTier(): string {
    return this.getGoogleFieldValue(WalletGoogleField.Row2Right);
  }

  get HexBackgroundColor(): string {
    return this.getGoogleFieldValue(WalletGoogleField.HexBackgroundColor);
  }

  get HexFontColor(): string {
    return this.getGoogleFieldValue(WalletGoogleField.HexFontColor);
  }

  get BarcodeValue(): string {
    return this.getGoogleFieldValue(WalletGoogleField.BarcodeValue);
  }

  // get HeroImage(): string {
  //   return this.getGoogleFieldValue(WalletGoogleField.HeroImage);
  // }

  get HeroImageUrl(): SafeStyle {
    if (this.mediaModel && this.mediaModel.walletGoogleImageUID) {
      return this.getImage( this.mediaModel.walletGoogleImageUID, 512);
    }

    return this.getImage(this.getGoogleFieldValue(WalletGoogleField.HeroImage), 512);
 }

  // get LogoImage(): string {
  //   return this.getGoogleFieldValue(WalletGoogleField.LogoImage);
  // }

  get LogoImageUrlAsync(): Promise<SafeStyle> {
    if (this.mediaModel && this.mediaModel.walletGoogleLogoUID) {
      return this.getImageAsync( this.mediaModel.walletGoogleLogoUID, 512);
    }
    return this.getImageAsync(this.getGoogleFieldValue(WalletGoogleField.LogoImage), 512);
  }

  get LogoImageUrl(): SafeStyle {
    if (this.mediaModel && this.mediaModel.walletGoogleLogoUID) {
      return this.getImage( this.mediaModel.walletGoogleLogoUID, 512);
    }
    return this.getImage(this.getGoogleFieldValue(WalletGoogleField.LogoImage), 512);
  }

  get TextModulesData(): EvaluatedField[] {
    return this.getGoogleFields(WalletGoogleField.TextModulesData);
  }

  public getGoogleFields(fieldType: WalletGoogleField): EvaluatedField[] {
    return this.getFields(fieldType, this.walletTemplate, this.mediaModel);
  }

  public formatValue(discountValue: number, voucherDiscountType: number, valueCurrencyISOCode: string) {
    if (voucherDiscountType === 0) /* Cash */
    return `${discountValue} ${valueCurrencyISOCode}`;

    if (voucherDiscountType === 1) /* % */
    return `${discountValue} %`;
  }

  

  public formatDate(dateRaw: string) {
    return new Date(dateRaw).toLocaleDateString().replaceAll(' ', '');
  }

  Messages: string;
  PinLabel: string;
  Pin: string;
  BalanceUpdateTime: string;
  Details: string;
  FinePrint: string;
  ValidTimeInterval: string;
  Provider: string;

  constructor(
    sanitizer: DomSanitizer,
    globals: Globals,
    service: GalleryService,
    private companyService: CompanyService,
    private transService: TranslationService
  ) {
    super(globals, sanitizer, service);
    this._globals = globals;
    this._sanitizer = sanitizer;
  }

  async ngOnInit() {
    this.companyService.setCompanyID = this.mediaModel.companyID;
    this.activeCompany = await this.companyService.getActive().toPromise()
                          .catch((e) => {
                            return null;
                          });
  }

  public getFinalValue(modelProperty: string, fieldType: WalletGoogleField) {
    if (!isNullOrWhitespace(modelProperty)) {
      return this.transService.instant(modelProperty);
    }
    return this.transService.instant(this.getFieldValue(fieldType, this.walletTemplate, this.mediaModel));
  }

  public getFirstValidValue(...values: string[]) {
    for (const value of values) {
      if (!isNullOrWhitespace(value)) {
        return value;
      }
    }
    return null;
  }
}
